<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
         <h3 class="p-2">
            <small class="text-muted">Recall Detail - Dashboard View</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-2">
                <label for="module">Recall Number</label>
                <input type="text" class="form-control" id="recall-no" v-model="r.recallNo" disabled>
            </div>
            <div class="form-group col-2">
                <label for="module">Qty</label>
                <input type="number" class="form-control" id="qty" v-model="r.qty" disabled>
            </div>
        </div>
        <div v-if="this.r.module === 'ncr' || this.r.ncrId" class="row">
            <div class="form-group col-3">
                <label for="subject">Product</label>
                <input type="text" class="form-control" id="recall-no" v-model="r.productName" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Customer Name</label>
                <input type="text" class="form-control" id="recall-no" v-model="r.customerName" disabled>
            </div>
            <div class="form-group col-2">
                <label for="module">Discharge Port</label>
                <input type="text" class="form-control" id="recall-no" v-model="r.dischargePortName" disabled>
            </div>
            <div class="form-group col-2">
                <label for="module">Country Name</label>
                <input type="text" class="form-control" id="container-no" v-model="r.countryName" disabled>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <label for="module">Analysis Report of Retain Sample</label>
                <textarea class="form-control" id="description" v-model="r.analysis" rows="3" disabled></textarea>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="subject">Recall Process Step</label>
                <input type="text" class="form-control" id="customer" v-model="r.recallProcessStep" disabled>
            </div>
            <div class="form-group col-3">
                <label for="subject">Non Conformance Process Step</label>
                <input type="text" class="form-control" id="brand" v-model="r.nonConformanceProcessStep" disabled>
            </div>
            <div class="form-group col-3">
                <label for="subject">Recall Start Date</label>
                <flat-pickr  style="background-color:white;" class="form-control" v-model="r.recallStartDate" disabled></flat-pickr>
            </div>
            <div class="form-group col-3">
                <label for="subject">Recall Finish Date</label>
                <flat-pickr  style="background-color:white;" class="form-control" v-model="r.recallEndDate" disabled></flat-pickr>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-2">
                <label for="module">Claim Cost (USD)</label>
                <input type="number" class="form-control" id="pic" v-model="r.claimCost" disabled>
            </div>
            <div class="form-group col-2">
                <label for="module">Handling Recall Cost (USD)</label>
                <input type="number" class="form-control" id="handling-cost" v-model="r.handlingRecallCost" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Non Conformance Handling Cost (USD)</label>
                <input type="number" class="form-control" id="pic" v-model="r.nonConformanceHandlingCost" disabled>
            </div>
            <div class="form-group col-2">
                <label for="module">Other Cost (USD)</label>
                <input type="number" class="form-control" id="other-cost" v-model="r.otherCost" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Total Cost (USD)</label>
                <input type="number" class="form-control" id="other-cost" v-model="r.totalCost" disabled>
            </div>
        </div>
        <button type="button" v-if="this.r.customerComplaintId" class="btn btn-outline-success" @click="previewcparcc">Print CPAR-CC <i class="fas fa-print"></i></button>
        <button type="button" v-if="this.r.customerComplaintId" class="btn btn-outline-success" @click="previewccf">Print CCF <i class="fas fa-print"></i></button>
        <button type="button" v-if="this.r.ncrId" class="btn btn-outline-success" @click="previewcparncr">Print CPAR-NCR <i class="fas fa-print"></i></button>
        <br /><br />
        <button type="button" class="btn btn-outline-info" @click="cancel">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { recall } from '../../models/recall'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppNavBar from '../../components/AppNavbar.vue'
import AppDatatable from '../../components/AppDatatable.vue'

export default {
    components: {
        AppLookupField, AppDatePicker, AppNavBar, AppDropdown, AppDatatable
    },
    data() {
        return {
          r: {...recall, customerComplaint:[], customerComplaintCorrectiveInternal: []},
          moduleLists: [
                {
                    title: 'Customer Complaint',
                    value: 'customercomplaint'
                },
                {
                    title: 'NCR',
                    value: 'ncr'
                },
          ],
          productLookup: {
                id: 'product',
                title: 'Product',
                type: 'form',
                apiUrl: 'product-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Product',
                        width: 12,
                        column: 'productName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Nama',
                        column: 'name'
                    },
                    {
                        title: 'Plant Name',
                        column: 'plantName'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'productId'
                    },
                    {
                        from: 'name',
                        to: 'productName'
                    },
                ]
          },
          dischargePortLookup: {
                id: 'discharge-port',
                title: 'Discharge Port',
                type: 'form',
                apiUrl: 'discharge-port-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Discharge Port',
                        width: 12,
                        column: 'dischargePortName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Nama',
                        column: 'name'
                    },
                    {
                        title: 'Country',
                        column: 'countryName'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'dischargePortId'
                    },
                    {
                        from: 'name',
                        to: 'dischargePortName'
                    },
                    {
                        from: 'countryId',
                        to: 'countryId'
                    },
                    {
                        from: 'countryName',
                        to: 'countryName'
                    },
                ]
          },

          customerLookup: {
                id: 'customer',
                title: 'Customer',
                type: 'form',
                apiUrl: 'customer-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Customer',
                        width: 12,
                        column: 'customerName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Nama',
                        column: 'name'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'customerId'
                    },
                    {
                        from: 'name',
                        to: 'customerName'
                    },
                ]
          },

          ccLookup: {
                id: 'cc-list',
                title: 'Customer Complaint List',
                type: 'form',
                apiUrl: 'recall-cc-list',
                filter: ['complaintNo'],
                fields: [
                    {
                        placeholder: 'Complaint No',
                        width: 12,
                        column: 'complaintNo'
                    }
                ],
                dtElements: [
                    {
                        title: 'Complaint No',
                        column: 'complaintNo'
                    },
                ],
                affectedField: [
                    {
                        from: 'customerComplaintId',
                        to: 'customerComplaintId'
                    },
                    {
                        from: 'complaintNo',
                        to: 'complaintNo'
                    },
                ]
          },
          ncrLookup: {
                id: 'ncr-list',
                title: 'Customer Complaint List',
                type: 'form',
                apiUrl: 'recall-ncr-list',
                filter: ['ncrNo'],
                fields: [
                    {
                        placeholder: 'NCR No',
                        width: 12,
                        column: 'ncrNo'
                    }
                ],
                dtElements: [
                    {
                        title: 'NCR No',
                        column: 'ncrNo'
                    },
                ],
                affectedField: [
                    {
                        from: 'ncrId',
                        to: 'ncrId'
                    },
                    {
                        from: 'ncrNo',
                        to: 'ncrNo'
                    },
                ]
          },
          dtElementsCC: [
            {
                title: 'Complaint No',
                column: 'complaintNo',
                type: 'text',
                width: 8,
            },
            {
                title: 'Customer Name',
                column: 'customerName',
                type: 'text',
                width: 8,
            },
            {
                title: 'ProductName',
                column: 'productName',
                type: 'text',
                width: 8,
            },
          ],
          dtElementsInternal: [
              {
                title: 'Root Cause',
                column: 'rootCause',
                type: 'dropdown',
                width: 6,
                lists: [
                    {
                        title: 'Machine',
                        value: 'machine'
                    },
                    {
                        title: 'Man',
                        value: 'man'
                    },
                    {
                        title: 'Material',
                        value: 'material'
                    },
                    {
                        title: 'Method',
                        value: 'method'
                    },
                    {
                        title: 'Environment',
                        value: 'environment'
                    }
                ]
              },
              {
                title: 'Corrective',
                column: 'corrective',
                type: 'text',
                width: 6,
              },
              {
                title: 'Corrective Responder Name',
                column: 'correctiveResponderName',
                type: 'lookup',
                width: 6,
                lookup: {
                    id: 'memberCorrective',
                    title: 'Member Data',
                    type: 'table',
                    apiUrl: 'member-management/lookup',
                    filter: ['firstName', 'lastName', 'email'],
                    fields: [
                        {
                            placeholder: 'Corrective Responder Name',
                            width: 5,
                            column: 'correctiveResponderName'
                        }
                    ],
                    dtElements: [
                        {
                            title: 'First Name',
                            column: 'firstName'
                        },
                        {
                            title: 'Last Name',
                            column: 'lastName'
                        },
                        {
                            title: 'Email',
                            column: 'email'
                        },
                    ],
                    affectedField: [
                        {
                            from: 'id',
                            to: 'correctivePicId'
                        },
                        {
                            from: 'firstName',
                            to: 'correctiveResponderName'
                        },
                        {
                            from: 'email',
                            to: 'correctiveResponderEmail'
                        },
                    ]
                },
                disable: true,
              },
              {
                title: 'Corrective Responder Email',
                column: 'correctiveResponderEmail',
                type: 'text',
                width: 4,
                disable: true,
              },
              {
                title: 'Corrective Target Date',
                column: 'correctiveTargetDate',
                type: 'date',
                width: 4,
                disable: true,
              },
              {
                title: 'Preventive',
                column: 'preventive',
                type: 'text',
                width: 6,
              },
              {
                title: 'Preventive Responder Name',
                column: 'preventiveResponderName',
                type: 'lookup',
                width: 6,
                lookup: {
                    id: 'memberPreventive',
                    title: 'Member Data',
                    type: 'table',
                    apiUrl: 'member-management/lookup',
                    filter: ['firstName', 'lastName', 'email'],
                    fields: [
                        {
                            placeholder: 'Preventive Responder Name',
                            width: 5,
                            column: 'preventiveResponderName'
                        }
                    ],
                    dtElements: [
                        {
                            title: 'First Name',
                            column: 'firstName'
                        },
                        {
                            title: 'Last Name',
                            column: 'lastName'
                        },
                        {
                            title: 'Email',
                            column: 'email'
                        },
                    ],
                    affectedField: [
                        {
                            from: 'id',
                            to: 'preventivePicId'
                        },
                        {
                            from: 'firstName',
                            to: 'preventiveResponderName'
                        },
                        {
                            from: 'email',
                            to: 'preventiveResponderEmail'
                        },
                    ]
                },
                disable: true,
              },
              {
                title: 'Preventive Responder Email',
                column: 'preventiveResponderEmail',
                type: 'text',
                width: 4,
                disable: true,
              },
              {
                title: 'Preventive Target Date',
                column: 'preventiveTargetDate',
                type: 'date',
                width: 4,
                disable: true,
              },
          ],
        }
    },
    watch: {
        'r': {
            handler: function() {
                // watch deeply for every changes on rsdetail to calculate sample cost
                // for(let i=0; i<this.rs.requestSampleDetail.length;i++) {
                //     const uomId = this.rs.requestSampleDetail[i].UOM
                //     const uom = listUom.find(x => x.value === uomId)
                //     this.rs.requestSampleDetail[i].sampleCost = this.rs.requestSampleDetail[i].qty * this.rs.requestSampleDetail[i].sampleCostMT * (uom ? uom.conversion : 0)
                // }
                const claimCost = this.r.claimCost
                const handlingRecallCost = this.r.handlingRecallCost
                const nonConformanceHandlingCost = this.r.nonConformanceHandlingCost
                const otherCost = this.r.otherCost
                this.r.totalCost = +claimCost + +handlingRecallCost + +nonConformanceHandlingCost + +otherCost
            },
            deep: true
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const rApi = api('recall-dashboard')
            this.r = await rApi.getWithParams(this.$route.query.id)
        }
    },
    methods: {
        cancel() {
            this.$router.go(-1)
        },
        async finishLookup(data) {
            const currentr = this.r
            this.r = {
                ...currentr,
                ...data
            }
            // const rApi = api('recall-cc-data')
            // const ccData = await rApi.getWithParams(this.r.customerComplaintId)
            // this.r.customerComplaint = ccData[0]
            // this.r.customerComplaintCorrectiveInternal = ccData[1]
        },
        checkModule() {
            if (this.r.module === 'customercomplaint') {
                console.log('hapus NCR')
                this.r.customerComplaintId = ''
                this.r.complaintNo = ''
                this.r.countryId = ''
                this.r.productId = ''
                this.r.dischargePortId = ''
                this.r.countryName = ''
                this.r.productName = ''
                this.r.dischargePortName = ''
                this.r.customerId = ''
                this.r.customerName = ''
                this.r.conformanceTypeId = ''
                this.r.conformanceTypeName = ''
            } else if(this.r.module === 'ncr') {
                console.log('hapus CC')
                this.r.ncrId = ''
                this.r.ncrNo = ''
                this.r.countryId = ''
                this.r.productId = ''
                this.r.dischargePortId = ''
                this.r.countryName = ''
                this.r.productName = ''
                this.r.dischargePortName = ''
                this.r.customerId = ''
                this.r.customerName = ''
                this.r.conformanceTypeId = ''
                this.r.conformanceTypeName = ''
            }
        },
        previewcparcc() {
            if(this.selectedId !== '') {
                // this.$router.push({
                //     name: 'cpar-cc',
                //     query: {
                //         id: this.r.customerComplaintId
                //     }
                // })
                let newTab = this.$router.resolve({name: 'cpar-cc', query: {id: this.r.customerComplaintId}});
                window.open(newTab.href, '_blank');
            }
        },
        previewccf() {
            if(this.selectedId !== '') {
                // this.$router.push({
                //     name: 'ccf',
                //     query: {
                //         id: this.r.customerComplaintId
                //     }
                // })
                let newTab = this.$router.resolve({name: 'ccf', query: {id: this.r.customerComplaintId}});
                window.open(newTab.href, '_blank');
            }
        },
        previewcparncr() {
            if(this.selectedId !== '') {
                // this.$router.push({
                //     name: 'cpar-ncr',
                //     query: {
                //         id: this.r.ncrId
                //     }
                // })
                let newTab = this.$router.resolve({name: 'cpar-ncr', query: {id: this.r.ncrId}});
                window.open(newTab.href, '_blank');
            }
        },
    }
}
</script>